import certificateImageRight from '/pictures/certificate-2.jpg';
import { StyledMarkdown } from '@components/atoms/StyledMarkdown';
import certificateImageLeft from '/pictures/certificate-1.jpg';

interface ProductCertificateProps {
  certificate: {
    title?: string;
    content?: string;
  };
}

export function ProductCertificate({ certificate }: ProductCertificateProps) {
  return (
    <div className="bg-white rounded-bonusLarge shadow-lg p-6 font-light print:break-inside-avoid">
      <h2 className="font-bold text-xl mb-6">{certificate.title}</h2>
      <StyledMarkdown markdown={certificate.content} />
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 print:grid-cols-2">
        <div className="min-w-[280px] bg-gray-100 rounded-lg overflow-hidden">
          <img
            src={certificateImageLeft}
            alt="Left certificate image"
            className="w-full h-auto object-contain"
          />
        </div>
        <div className="min-w-[280px] bg-gray-100 rounded-lg overflow-hidden">
          <img
            src={certificateImageRight}
            alt="Right certificate image"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
}
